module.exports = __webpack_public_path__ + "static/img/training_system_s2_max.6e2564b0.png";